<template>
    <el-container direction="vertical">
        <el-row class="income-header">
            <el-col :xs="24" :sm="16" :md="16" :lg="16">
                <div class="income-subtitle">
                    ID {{ income.id }} (создан {{ income.created_by_name }} {{ income.created_at }})
                </div>
                <div class="income-title">
                    Карточка безналичного прихода
                    <el-button
                        type="warning"
                        icon="el-icon-delete"
                        size="mini"
                        v-if="canDeleteIncome && isEdit"
                        @click="confirmDeleteIncome"
                    />
                </div>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" :lg="8" class="actions">
                <template v-if="isCanEditIncome">
                    <template v-if="isEdit">
                        <span class="action-title action-edit" @click="save">
                            Сохранить
                        </span>
                    </template>
                    <template v-else>
                        <span class="action-title action-edit" @click="edit">
                            Редактировать
                        </span>
                    </template>
                </template>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <div class="income-main" v-loading="loadingMain">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="7" :lg="7">
                    <el-row>
                        <el-col :span="10" class="gray">
                            Статус
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-select
                                    v-model="income.operation_status_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    size="mini"
                                >
                                    <el-option v-for="item in operationStatusesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.operation_status_id" v-text="errors.operation_status_id[0]"></div>
                            </template>
                            <template v-else>
                                {{ income.operation_status_name }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Вид оплаты
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit && isIncomeCashLessAccountant">
                                <el-select
                                    v-model="income.pay_type_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    filterable
                                    size="mini"
                                >
                                    <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.pay_type_id" v-text="errors.pay_type_id[0]"></div>
                            </template>
                            <template v-else>
                                {{ payTypeName }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Статья
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-select
                                    v-model="income.detail_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    size="mini"
                                >
                                    <el-option v-for="item in detailsList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.detail_id" v-text="errors.detail_id[0]"></div>
                            </template>
                            <template v-else>
                                {{ income.detail_name }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Дата поступления
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-date-picker
                                    v-model="income.date"
                                    type="date"
                                    placeholder="дд.мм.гггг"
                                    format="dd.MM.yyyy"
                                    value-format="dd.MM.yyyy"
                                    :picker-options="pickerOptions"
                                    :clearable="false"
                                    size="mini"
                                    class="w100"
                                />
                                <div class="field-error bold" v-if="errors.date" v-text="errors.date[0]"></div>
                            </template>
                            <template v-else>
                                {{ income.date }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Сумма, руб
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <auto-numeric
                                    v-model="income.amount"
                                    :options="setAutonumericOptions"
                                    class="autonumeric"
                                />
                                <div class="field-error bold" v-if="errors.amount" v-text="errors.amount[0]"></div>
                            </template>
                            <template v-else>
                                {{ income.amount }}
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                    <el-row>
                        <el-col :span="10" class="gray">
                            Офис
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-select
                                    v-model="income.office_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    filterable
                                    size="mini"
                                    :disabled="dealIdParam !== null"
                                >
                                    <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.office_id" v-text="errors.office_id[0]"></div>
                            </template>
                            <template v-else>
                                {{ officeName }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Договор №
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-select
                                    v-model="income.deal_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    placeholder="Поиск по номеру договора"
                                    filterable
                                    remote
                                    reserve-keyword
                                    :remote-method="searchDealByContractNumber"
                                    @change="handleDealSelected"
                                    size="mini"
                                    :disabled="dealIdParam !== null"
                                >
                                    <el-option v-for="item in dealsList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.received_from_id" v-text="errors.received_from_id[0]"></div>
                            </template>
                            <template v-else-if="contactDeal">
                                {{ contactDeal.name }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row v-if="contactDeal">
                        <el-col>
                            <template v-if="contactDeal">
                                <span class="gray">Сделка </span><a class="link" target="_blank" :href="getDealLink(contactDeal.id)">#{{ contactDeal.id }}</a>,
                                {{ contactDeal.contact_name }} {{ contactDeal.contact_phone }} {{ contactDeal.address }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row v-if="contactDeal">
                        <el-col :span="12">
                            <el-row>
                                <el-col>
                                    <span class="gray">Бюджет сделки </span>
                                    <span v-loading="loadingDebt">{{ formatFinance(contactDeal.budget) }} руб.</span>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row>
                                <el-col>
                                    <span class="gray">Долг клиента </span>
                                    <span v-loading="loadingDebt">{{ formatFinance(contactDebt) }} руб.</span>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-row>
                        <el-col class="gray pt10">
                            Комментарий
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <template v-if="isEdit">
                                <el-input
                                    size="mini"
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="income.comment"
                                />
                                <div class="error" v-if="errors.comment">
                                    {{ errors.comment[0] }}
                                </div>
                            </template>
                            <template v-else>
                                <div v-format-text="income.comment">
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </el-container>
</template>

<script>
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import IncomeMixin from '@/mixins/income';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import '@/assets/styles/card.scss';
import '@/assets/styles/incomes.scss';
import { formatFinance } from '@/common/utilities';
import localReferences from '@/helpers/localReferences';

library.add(faSave);
const initialCashIncome = {
    id: null,
    operation_type_id: null,
    created_by_id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    date: moment().format('DD.MM.YYYY'),
    operation_status_id: null,
    received_by_type: null,
    received_by_id: null,
    received_from_type: null,
    received_from_id: null,
    pay_type_id: null,
    detail_id: null,
    deal_id: null,
    office_id: null,
    amount: null,
    comment: null,
    operation_status_name: '',
    operation_type_name: '',
    pay_type_name: '',
    received_by_name: '',
    received_from_name: '',
    created_by_name: '',
    amount_formatted: ''
};

export default {
    name: 'IncomeCashlessCard',
    components: {
        AutoNumeric
    },
    mixins: [
        IncomeMixin
    ],
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            income: { ...initialCashIncome },
            errors: [],
            dealsList: [],
            contactDebt: null,
            contactDeal: null,
            loadingMain: false,
            loadingDebt: false,
            numericMinimumValue: '-9999999999999'
        };
    },
    computed: {
        setAutonumericOptions() {
            if (this.isIncomeCashLessAccountant) {
                return Object.assign(this.numericOptions, { minimumValue: this.numericMinimumValue });
            }
            return this.numericOptions;
        },
        isNew() {
            return this.id === 'new' || this.id === 0;
        },
        dealIdParam() {
            return this.$route.params.dealId || null;
        },
        isEdit() {
            return this.$route.meta.editMode && this.isCanEditIncome;
        },
        isCanEditIncome() {
            if (this.income.operation_status_id === this.localReferences.operationStatuses.executed) {
                if (this.isIncomesCashLessEmployer) {
                    return false;
                }
                return this.isIncomeCashLessAccountant;
            } else {
                return this.isIncomesCashLessEmployer || this.isIncomeCashLessAccountant;
            }
        },
        officeList() {
            return this.$store.state.references.offices.filter(office => office.id !== this.localReferences.offices.all);
        },
        payTypesList() {
            return this.$store.state.references.payTypes.filter(payType => !this.localReferences.payTypesFullCash.includes(payType.id));
        },
        operationStatusesList() {
            if (this.isIncomesCashLessEmployer) {
                return this.$store.state.references.operationStatuses.filter(
                    operationStatus => operationStatus.id !== this.localReferences.operationStatuses.executed
                );
            }
            return this.$store.state.references.operationStatuses;
        },
        cashesList() {
            return this.$store.state.references.cashes;
        },
        officeName() {
            if (this.income && this.income.received_by) {
                return this.income.received_by.office_name;
            }
            return '';
        },
        dealId() {
            return this.income.deal_id;
        },
        operationStatusId() {
            return this.income.operation_status_id;
        },
        payTypeId() {
            return this.income.pay_type_id;
        },
        officeId() {
            return this.income.office_id;
        },
        amount() {
            return this.income.amount;
        },
        isIncomeCashLessAccountant() {
            return this.$store.getters.isIncomeCashLessAccountant;
        },
        isIncomesCashLessEmployer() {
            return this.$store.getters.isIncomesCashLessEmployer;
        },
        canDeleteIncome() {
            return this.isIncomeCashLessAccountant && !this.isNew && this.income.operation_status_id === this.localReferences.operationStatuses.new;
        },
        payTypeName() {
            return this.getNameFromListById(this.payTypesList, this.income.pay_type_id);
        }
    },
    beforeMount() {
        if (this.isNew) {
            this.income.created_by_id = this.$store.state.auth.employerId;
            this.income.created_by_name = this.$store.state.auth.name;
            this.income.operation_status_id = this.localReferences.operationStatuses.new;
            this.income.operation_type_id = this.localReferences.operationTypes.deal;
            this.income.received_by_type = 'cash';
            this.income.received_from_type = 'contact';
            if (this.isIncomesCashLessEmployer) {
                this.income.pay_type_id = this.localReferences.payTypesFull.pos;
            }
            if (this.dealIdParam) {
                this.getDealById(this.dealIdParam);
                this.income.pay_type_id = this.localReferences.payTypesFull.pos;
            }
            this.income.detail_id = localReferences.incomeDetails.prepayment;
        }
    },
    mounted() {
        if (!this.isNew) {
            this.getIncome();
        }
    },
    methods: {
        confirmDeleteIncome() {
            this.$confirm('Приход будет удален?', 'Внимание', {
                confirmButtonText: 'Удалить',
                cancelButtonText: 'Отмена',
                type: '',
                center: true
            }).then(() => {
                this.deleteIncome();
            }).catch(() => {
            });
        },
        handleDealSelected(dealId) {
            if (dealId) {
                this.updateFieldsByDealInfo(dealId);
            }
        },
        addDealToList() {
            if (!this.income.deal) {
                return;
            }
            this.dealsList = [{
                id: this.income.deal.id,
                name: `${this.income.deal.contract_number} от ${this.income.deal.contract_date}`,
                contact_id: this.income.deal.contact_id,
                contact_name: this.income.deal.contact ? this.income.deal.contact.name : '',
                contact_phone: this.income.deal.contact ? this.income.deal.contact.main_contact_phone : '',
                address: this.income.deal.address,
                budget: this.income.deal.budget,
                office_id: this.income.deal.responsibleUser ? this.income.deal.responsibleUser.office_id : null
            }];
        },
        setOfficeByIncomeCash() {
            if (!this.income.office_id && this.income.received_by_type === 'cash' && this.income.received_by_id) {
                this.income.office_id = this.income.received_by.office_id;
            }
        },
        updateFieldsByDealInfo(dealId) {
            if (this.dealsList.length === 0 || !dealId) {
                return;
            }
            this.contactDeal = this.dealsList.find(deal => deal.id === dealId);
            if (this.contactDeal.contact_id) {
                this.getDealContactDebt(dealId, this.contactDeal.contact_id);
                this.income.received_from_id = this.contactDeal.contact_id;
            }
            if (this.isNew && this.contactDeal.office_id) {
                this.income.office_id = this.contactDeal.office_id;
            }
        },
        edit() {
            if (this.isCanEditIncome) {
                this.$router.push({ name: 'income-cashless-card', params: { id: '' + this.income.id } });
            }
        },
        save() {
            if (this.isNew) {
                this.createIncome();
            } else {
                this.updateIncome();
            }
        },
        close() {
            if (this.isNew) {
                this.$router.go(-1);
            }
            if (this.isEdit) {
                this.$router.push({ name: 'income-cashless-card-view', params: { id: '' + this.income.id } });
            } else {
                this.$router.push({ name: 'incomes-cashless' });
            }
        },
        async getIncome() {
            this.loadingMain = true;
            try {
                this.income = await this.$store.dispatch('incomes/getIncome', this.id);
                this.addDealToList();
                this.setOfficeByIncomeCash();
                this.updateFieldsByDealInfo(this.income.deal_id);
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        async createIncome() {
            this.income.received_by_id = this.getReceivedById();
            this.loadingMain = true;
            try {
                this.income = await this.$store.dispatch('incomes/createIncome', { ...this.income });
                this.addDealToList();
                this.setOfficeByIncomeCash();
                this.updateFieldsByDealInfo(this.income.deal_id);
                this.goIncomeCard(this.income.id);
            } catch (e) {
                this.errors = JSON.parse(e.message);
            } finally {
                this.loadingMain = false;
            }
        },
        async updateIncome() {
            if (this.income.pay_type_id && this.income.office_id && this.income.received_by_id === null) {
                this.income.received_by_id = this.getReceivedById();
            }
            this.loadingMain = true;
            try {
                this.income = await this.$store.dispatch('incomes/updateIncome', { ...this.income });
                this.addDealToList();
                this.setOfficeByIncomeCash();
                this.updateFieldsByDealInfo(this.income.deal_id);
                this.goIncomeCard(this.income.id);
            } catch (e) {
                this.errors = JSON.parse(e.message);
            } finally {
                this.loadingMain = false;
            }
        },
        async deleteIncome() {
            this.loadingMain = true;
            try {
                await this.$store.dispatch('incomes/deleteIncome', this.income.id);
                this.goList();
            } catch (e) {
                console.log(e.message);
            } finally {
                this.loadingMain = false;
            }
        },
        async getDealContactDebt(dealId, contactId) {
            this.loadingDebt = true;
            try {
                this.contactDebt = await this.$store.dispatch('debts/getDealContactDebt', { dealId, contactId });
            } catch (e) {
                console.log(e.message);
            } finally {
                this.loadingDebt = false;
            }
        },
        searchDealByContractNumber(queryString) {
            if (queryString.length < 3) {
                return [];
            }
            this.$store.dispatch('search/searchDealsByContractNumber', { query: queryString }).then(
                response => {
                    this.dealsList = [...response];
                }
            ).catch(() => {
                this.dealsList = [];
            });
        },
        goIncomeCard(id) {
            this.$router.push({ name: 'income-cashless-card-view', params: { id: '' + id } });
        },
        goList() {
            this.$router.push({ name: 'incomes-cashless' });
        },
        getNameFromListById(list, searchedId) {
            if (Object.keys(list).length !== 0) {
                const foundItem = list.find(item => item.id === searchedId);
                return foundItem ? foundItem.name : '';
            }
            return '';
        },
        getDealById(dealId) {
            this.$store.dispatch('deals/getDealById', dealId).then(
                response => {
                    this.dealsList = [Object.assign({}, response, {
                        name: `${response.contract_number} от ${response.contract_date}`,
                        office_id: response.responsible_user ? response.responsible_user.office_id : null
                    })];
                    this.income.deal_id = response.id;
                    this.updateFieldsByDealInfo(this.income.deal_id);
                }).finally(() => {
            });
        },
        getReceivedById() {
            if (this.income.office_id && this.income.pay_type_id) {
                const cash = this.cashesList.find(cash => cash.office_id === this.income.office_id && cash.pay_type_category_id === this.income.pay_type_id);
                return cash ? cash.id : null;
            }
            return null;
        },
        formatFinance
    },
    watch: {
        dealId(newValue, oldValue) {
            if (oldValue === null && newValue && this.errors.received_from_id) {
                this.errors.received_from_id = null;
            }
        },
        operationStatusId(newValue, oldValue) {
            if (newValue === this.localReferences.operationStatuses.executed && oldValue !== this.localReferences.operationStatuses.executed) {
                this.contactDebt -= this.amount;
            }
            if (newValue !== this.localReferences.operationStatuses.executed && oldValue === this.localReferences.operationStatuses.executed) {
                this.contactDebt += this.amount;
            }
        },
        amount(newValue, oldValue) {
            if (this.income.operation_status_id === this.localReferences.operationStatuses.executed) {
                this.contactDebt = this.contactDebt + oldValue - newValue;
            }
            if (oldValue === null && newValue && this.errors.amount) {
                this.errors.amount = null;
            }
        },
        payTypeId(newValue, oldValue) {
            if (oldValue === null && newValue && this.errors.pay_type_id) {
                this.errors.pay_type_id = null;
            }
        },
        officeId(newValue, oldValue) {
            if (oldValue === null && newValue && this.errors.office_id) {
                this.errors.office_id = null;
            }
            if (newValue) {
                this.income.received_by_id = this.getCashId(this.income.pay_type_id, newValue);
            }
        },
        id(value) {
            if (value) {
                this.getIncome();
            }
        }
    }
};
</script>
